<template>
  <b-card
    no-body
    :class="(toPage? 'link-card' : null) && flatCard? 'flat-card' : ''"
    @click="goPage(toPage)"
  >
    <b-card-body class="d-flex justify-content-between align-items-center">
      <div class="truncate">
        <b-row>
          <b-col
            md="12"
            cols="12"
          >
            <h2
              v-if="Number(value) === Number(totals) || Number(totals) === 0"
              class="mb-25 font-weight-bolder"
            >
              <span v-if="prefix">{{ prefix }}</span>
              <span>
                {{ value | toNumber }}
              </span>
              <span v-if="suffix">{{ suffix }}</span>
            </h2>
            <h2
              v-else
              class="mb-25 font-weight-bolder"
            >
              <span v-if="prefix">{{ prefix }}</span>
              <span>
                {{ value | toNumber }}  / {{ totals | toNumber }}
              </span>
              <span v-if="suffix">{{ suffix }}</span>
            </h2>
            <span>{{ title }}</span>
          </b-col>
          <b-col
            class="mt-1"
          >
            <h5
              v-if="Number(value) === Number(totals) || Number(totals) === 0"
              class="mb-25 font-weight-bolder text-secondary"
            >
              <span v-if="prefix">{{ prefix }}</span>
              <span>
                {{ value1 | toNumber }}
              </span>
              <span v-if="suffix">{{ suffix }}</span>
            </h5>
            <small>{{ title1 }}</small>
          </b-col>
          <b-col
            class="mt-1"
          >
            <h5
              v-if="Number(value) === Number(totals) || Number(totals) === 0"
              class="mb-25 font-weight-bolder text-secondary"
            >
              <span v-if="prefix">{{ prefix }}</span>
              <span>
                {{ value2 | toNumber }}
              </span>
              <span v-if="suffix">{{ suffix }}</span>
            </h5>
            <small>{{ title2 }}</small>
          </b-col>
        </b-row>
        <div
          v-if="subTitle"
          class="font-small-2 text-muted"
        >
          {{ subTitle }}
        </div>
      </div>
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BAvatar, BCard, BCardBody, BRow, BCol,
} from 'bootstrap-vue'

export default {
  name: 'DefaultNewCard',
  components: {
    BAvatar, BCard, BCardBody, BRow, BCol,
  },
  props: {
    flatCard: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    value1: {
      type: [String, Number],
      required: true,
    },
    value2: {
      type: [String, Number],
      required: true,
    },
    totals: {
      type: [String, Number],
      default: '0',
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    title1: {
      type: String,
      required: true,
    },
    title2: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    toPage: {
      type: String,
      default: null,
    },
  },
  methods: {
    goPage(url) {
      if (url) {
        this.$router.push(url)
      }
    },
  },
}
</script>
<style>
.flat-card{
  background-color: transparent !important;
  box-shadow: none !important;
}
.link-card{
  cursor: pointer !important;
}
</style>
